import { ExpectedFileColumn } from "../../app/models/requestModels/fileExpectedColumn";
import { EMAIL_REGEX, phoneRegex } from "../fdp/FdpConstants";

export enum USER_COLUMN_NAME {
  USER_ID = "id",
  USER_NAME = "userName",
  FIRSTNAME = "firstName",
  LASTNAME = "lastName",
  EMAIL = "email",
  USER_DOCS = "userRelatedDocs",
  PHONE = "phone",
  DELETED = "deleted",
  USER_ACTIONOWNER_TYPE = "userActionOwnerType",
  CREATED_ON = "createdOn",
  UPDATED_ON = "updatedOn",
  ASSIGNED_ROLES = "assignedRoles",
  ASSIGNED_PARCEL_CENTERS = "assignedParcelCenters",
}

export enum USER_LABEL_NAME {
  USER_ID = "User ID",
  USER_NAME = "Username",
  FIRSTNAME = "First name",
  LASTNAME = "Last name",
  EMAIL = "Email",
  PHONE = "Phone",
  DELETED = "Active",
  USER_ACTIONOWNER_TYPE = "Action Owner",
  CREATED_ON = "Created On",
  UPDATED_ON = "Updated On",
  ASSIGNED_ROLES = "Role",
  ASSIGNED_PARCEL_CENTERS = "Parcel Center",
  ONE_TIME_PASSWORD = "One Time Password",
  USER_DOCS = "Docs",
}

export const USER_FILTER_COLUMN_OPTIONS = [
  {
    label: USER_LABEL_NAME.USER_NAME,
    value: USER_COLUMN_NAME.USER_NAME,
  },
  {
    label: USER_LABEL_NAME.EMAIL,
    value: USER_COLUMN_NAME.EMAIL,
  },
  {
    label: USER_LABEL_NAME.PHONE,
    value: USER_COLUMN_NAME.PHONE,
  },
  {
    label: USER_LABEL_NAME.DELETED,
    value: USER_COLUMN_NAME.DELETED,
  },
  {
    label: USER_LABEL_NAME.ASSIGNED_ROLES,
    value: USER_COLUMN_NAME.ASSIGNED_ROLES,
  },
  {
    label: USER_LABEL_NAME.ASSIGNED_PARCEL_CENTERS,
    value: USER_COLUMN_NAME.ASSIGNED_PARCEL_CENTERS,
  },
];

export const UserExpectedColumns: ExpectedFileColumn[] = [
  {
    name: "Firstname",
    mandatory: true,
    type: "string",
    camelCaseName: "firstname",
  },
  {
    name: "Lastname",
    mandatory: false,
    type: "string",
    camelCaseName: "lastname",
  },
  {
    name: "Email",
    mandatory: true,
    type: "string",
    regex: EMAIL_REGEX,
    camelCaseName: "email",
  },
  {
    name: "Phone",
    mandatory: false,
    type: "string",
    regex: phoneRegex,
    camelCaseName: "phone",
  },
  {
    name: "Roles",
    mandatory: true,
    type: "string,[]",
    camelCaseName: "roles",
  },
  {
    name: "Parcel Center IDs",
    mandatory: false,
    type: "number,[]",
    camelCaseName: "parcelCenterIds",
  },
]
